import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/lib/site-config";

const LegalLayout = ({ title, children, testid }) => (
  <div className="min-h-screen bg-[#5C6B49] text-[#F3F1E8] py-16 px-4 sm:px-6 lg:px-8" data-testid={testid}>
    <div className="max-w-3xl mx-auto">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-[#C9C6B4] hover:text-[#E8E5D0] text-sm font-bold uppercase tracking-wider mb-10"
        data-testid="legal-back-btn"
      >
        <ArrowLeft size={14} /> Zurück
      </Link>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[0.95] mb-10">
        {title}
      </h1>
      <div className="space-y-6 text-[#E5E2D0] text-[15px] leading-relaxed [&_h2]:font-display [&_h2]:font-black [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-[#F3F1E8] [&_h3]:font-bold [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-[#F3F1E8] [&_p]:text-[#C9C6B4] [&_strong]:text-[#F3F1E8]">
        {children}
      </div>
    </div>
  </div>
);

const Impressum = () => {
  useEffect(() => {
    document.title = `Impressum · ${SITE.brand.fullName}`;
  }, []);
  return (
    <LegalLayout title="Impressum" testid="impressum-page">
      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        <strong>{SITE.brand.fullName}</strong>
        <br />
        Inhaber: {SITE.brand.owner}
        <br />
        {SITE.contact.address.street}
        <br />
        {SITE.contact.address.zip} {SITE.contact.address.city}
        <br />
        {SITE.contact.address.country}
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: {SITE.contact.phoneDisplay}
        <br />
        E-Mail: {SITE.contact.email}
      </p>

      <h2>Umsatzsteuer-ID</h2>
      <p>Wird auf Anfrage mitgeteilt.</p>

      <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
      <p>
        {SITE.brand.owner}
        <br />
        {SITE.contact.address.street}, {SITE.contact.address.zip}{" "}
        {SITE.contact.address.city}
      </p>

      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
        bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>

      <h2>Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung.
      </p>
    </LegalLayout>
  );
};

export default Impressum;
